import React from 'react';

import {DocumentNodes} from '../../../../common/document-nodes';
import {useRemainingNodesInfiniteQuery} from '../../../hooks/requests/use-remaining-nodes-infinite-query';
import {extractInfiniteQueryItems} from '../../../../../../components/pagination/infinite-query-items';
import {GlobalVersionData} from '../../../../../../hooks/global-version/use-global-version-query';
import {NodeSuggestion} from '../../../../common/sidebar-search-field/interface';

interface Props {
    usageAccession: string;
    searchData: NodeSuggestion;

    initialNodes: DocumentNode[];
    remaining: number;
    cursor: number;
    selectedGlobalVersion: GlobalVersionData;
    getDocumentLink: (documentId: string, nodeId?: string) => string;
}

export function ViewModeDocumentNodes({
    usageAccession,
    searchData,
    initialNodes,
    remaining,
    cursor,
    selectedGlobalVersion,
    getDocumentLink
}: Props) {
    const {documentAccession, nodeId} = searchData;

    const remainingUsagesNodesQuery = useRemainingNodesInfiniteQuery(
        {
            accession: documentAccession,
            declarationNodeId: nodeId,
            usageAccession,
            globalVersionId: selectedGlobalVersion.id,
            cursor
        },
        {
            initialData: {
                pages: [{parsedNodes: initialNodes, remaining, nextCursor: cursor}],
                pageParams: [{cursor}]
            }
        }
    );

    const handleMoreBtn = React.useCallback(() => {
        if (documentAccession && nodeId) {
            remainingUsagesNodesQuery.fetchNextPage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentAccession, nodeId]);

    const hasNextPage = remainingUsagesNodesQuery.hasNextPage ?? Boolean(remaining);
    const nodes = extractInfiniteQueryItems(remainingUsagesNodesQuery, (res) => res.parsedNodes);

    return (
        <DocumentNodes
            isLoading={remainingUsagesNodesQuery.isFetching}
            docAccession={usageAccession}
            nodes={nodes ?? []}
            hasNextPage={hasNextPage}
            onLoadNextPage={handleMoreBtn}
            getDocumentLink={getDocumentLink}
        />
    );
}
